import { inject, Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { SessionKeys } from '../constants';
import { GridPreviousNext } from '../models';
import { SessionService } from './session.service';

@Injectable({
  providedIn: 'root',
})
export class RouterService {
  private readonly sessionService = inject(SessionService);
  private readonly router = inject(Router);

  back(route: ActivatedRoute) {
    this.router.navigate(['./'], { relativeTo: route.parent, queryParams: { back: true } });
  }

  basket(route: ActivatedRoute) {
    this.router.navigate(['Basket'], { relativeTo: route.parent ?? route });
  }

  create(route: ActivatedRoute) {
    this.router.navigate(['Create'], { relativeTo: route.parent ?? route });
  }

  edit(id: string, route: ActivatedRoute) {
    this.router.navigate(['Edit', id], { relativeTo: route.parent ?? route });
  }

  // Edit a record on ANOTHER screen, named by its own address ('/Sales/Transfer'), where `edit`
  // above stays on the screen the component is already on. `replaceUrl` is for handing a record
  // on to the screen that owns it, so Back does not bounce the user straight back to the wrong
  // one (a transfer opened as a picking list).
  editOther(path: string, id: string, replaceUrl = false) {
    this.router.navigate([path, 'Edit', id], { replaceUrl });
  }

  path(path: string, route: ActivatedRoute) {
    this.router.navigate([path], { relativeTo: route.parent });
  }

  report(route: ActivatedRoute) {
    this.router.navigate(['Report'], { relativeTo: route.parent ?? route });
  }

  report2(route: ActivatedRoute) {
    this.router.navigate(['Report2'], { relativeTo: route.parent ?? route });
  }

  top() {
    this.router.navigate(['/']);
  }

  setPathIds(ids: string[]) {
    this.sessionService.setObject(SessionKeys.routeIds + location.pathname, ids);
  }

  previousNextIds(): GridPreviousNext {
    const pathname = location.pathname;
    const index = pathname.lastIndexOf('/Edit');
    const result: GridPreviousNext = {} as GridPreviousNext;
    if (index !== -1) {
      const parentRoute = pathname.substring(0, index);
      const id = pathname.substring(index + 6, index + 42);
      const routeIds: string[] = this.sessionService.getObject(SessionKeys.routeIds + parentRoute);
      if (routeIds) {
        const idIndex = routeIds.indexOf(id);
        if (idIndex > 0) {
          result.previousId = routeIds[idIndex - 1];
        }
        if (idIndex !== -1 && idIndex + 1 < routeIds.length) {
          result.nextId = routeIds[idIndex + 1];
        }
      }
    }
    return result;
  }
}
